module.exports = __webpack_public_path__ + "static/money1.7e8a7672.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/projects/money1.jpg
// module id = 359
// module chunks = 35783957827783